const BellIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00281 11.395C1.83446 12.4661 2.58712 13.2096 3.50867 13.5801C7.04168 15.0006 11.9582 15.0006 15.4913 13.5801C16.4128 13.2096 17.1655 12.4661 16.9971 11.395C16.8936 10.7367 16.382 10.1885 16.003 9.65326C15.5066 8.94355 15.4572 8.16945 15.4572 7.34588C15.4572 4.16313 12.79 1.58301 9.49996 1.58301C6.20989 1.58301 3.54277 4.16313 3.54277 7.34588C3.54269 8.16945 3.49337 8.94355 2.9969 9.65326C2.61787 10.1885 2.10628 10.7367 2.00281 11.395Z"
        stroke="#141B34"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 16.625C7.75527 17.1173 8.58758 17.4167 9.5 17.4167C10.4124 17.4167 11.2447 17.1173 11.875 16.625"
        stroke="#141B34"
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BellIcon;
